import React from "react";
import {
  ItemListadoMascotasReservas,
  useListarMascotasReservasHotel,
} from "../../../../services/reservasHotelServicios";
import TableSection from "./TableSection";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Model } from "../Model";
import DatosBasicos from "../DatosBasicos/DatosBasicos";
import { useWizard } from "../../../../hooks/wizard";
import { Row, Stack } from "react-bootstrap";
import SuccessButton from "../../../organisms/SuccessButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { usePasoReservaHotel } from "../pasoReservaHotel";
import { useQuery } from "@tanstack/react-query";
import {
  QUERY_BUSCAR_PROPIETARIO,
  buscarPropietario,
  RespuestaBuscarPropietario,
} from "../../../../services/propietariosServicios";

function SeleccionMascota({ model }: { model: Model }) {
  const {
    data,
    isLoading,
    isSuccess,
    error: errorListarMascotas,
  } = useListarMascotasReservasHotel();
  const { currentModel, seleccionarMascota, definirDatosPropietario } =
    usePasoReservaHotel(model);
  const { avanzar, avanza } = useWizard();

  const { error: errorDatosPropietario } = useQuery({
    queryKey: [QUERY_BUSCAR_PROPIETARIO],
    queryFn: async () => await buscarPropietario(currentModel.idPropietario),
    enabled: !!currentModel.idPropietario,
    onSuccess: (data: RespuestaBuscarPropietario) => {
      definirDatosPropietario({ datosPropietario: data });
    },
  });

  const puedeAvanzar =
    !!currentModel.idMascota && !!currentModel.datosPropietario;
  const error = errorListarMascotas || errorDatosPropietario;

  const onMascotaRowClick = (
    itemListadoMascotaReservas: ItemListadoMascotasReservas
  ) => {
    seleccionarMascota({
      idMascota: itemListadoMascotaReservas.id,
      idPropietario: itemListadoMascotaReservas.idPropietario,
      nombreMascota: itemListadoMascotaReservas.nombre,
      nombresPropietario: itemListadoMascotaReservas.nombresPropietario,
    });
  };

  if (error) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <DatosBasicos model={currentModel} />;
  }

  return (
    <Stack gap={2} className="p-2">
      <section className="d-flex gap-2 mx-3">
        <h5>Mascota seleccionada: </h5>
        {!!currentModel.nombreMascota && <h5>{currentModel.nombreMascota}</h5>}
      </section>
      <TableSection
        title={"Seleccionar mascota"}
        items={data || []}
        onRowClick={onMascotaRowClick}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <Row className="mb-2 justify-content-end">
        <SuccessButton
          type={"button"}
          style={{ width: "fit-content" }}
          disabled={!puedeAvanzar}
          onClick={avanzar}
        >
          Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
        </SuccessButton>
      </Row>
    </Stack>
  );
}

export default SeleccionMascota;
